import { useAtom, useSetAtom } from "jotai";
import { useEffect, useState } from "react";
import { globalSpinnerAtom, isMobileAtom } from "../store/layoutStore";
import { usePopover } from "./usePopover";
import { StyledBackdrop } from "../styles/globalsStyles";

const useMobileDetect = () => {
  const [isMobile, setMobile] = useAtom(isMobileAtom);
  const [hasLoadedIsMobile, setHasLoadedIsMobile] = useState(false);
  const setGlobalSpinner = useSetAtom(globalSpinnerAtom);
  const { showPopover, hidePopover } = usePopover();

  useEffect(() => {
    if (!hasLoadedIsMobile) {
      showPopover(<StyledBackdrop $useSecondaryColor />, {
        hidePopoverFrame: true
      });
    } else {
      hidePopover();
    }
  }, [hasLoadedIsMobile, hidePopover, showPopover]);

  useEffect(() => {
    setGlobalSpinner(!hasLoadedIsMobile);
  }, [setGlobalSpinner, hasLoadedIsMobile]);

  useEffect(() => {
    const handleResize = () => {
      setHasLoadedIsMobile(true);
      setMobile(window.innerWidth <= 768); // Adjust the threshold as needed
    };

    // Initial check on mount
    handleResize();

    // Listen for window resize events
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [setMobile]);

  return isMobile;
};

export default useMobileDetect;
